import { render } from "./chart-bar.vue?vue&type=template&id=bca75022"
import script from "./chart-bar.vue?vue&type=script&lang=js"
export * from "./chart-bar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__